import React, { Component } from 'react';
import '../../styles/components/status-tab.scss';
import ProjectCard from './ProjectCard';

class StatusCards extends Component {
  handleTabClick = (key) => {
    this.setState({ activeTab: key });

    if (this.props.onTabChange) {
      this.props.onTabChange(key);
    }
  };

  render() {
    const { activeTab, tabs } = this.props;

    return (
      <div className="status-cards">
        {tabs.map((tab) => (
          <ProjectCard
            key={tab.key}
            className={`${tab.key} ${activeTab === tab.key ? 'active' : ''}`}
            icon={tab.icon}
            title={tab.label}
            value={tab.count}
            onClick={() => this.handleTabClick(tab.key)}
          />
        ))}
      </div>
    );
  }
}

export default StatusCards;
